module.exports = __webpack_public_path__ + "static/media/alert.c10072a8.svg";